import React from "react";

export interface AiIconProps extends Omit<React.SVGProps<SVGSVGElement>, "color"> {
	/** Rendered width and height. Defaults to 16 (the icon's native grid). */
	size?: number | string;
	/** Stroke colour; defaults to currentColor so text colour utilities apply. */
	color?: string;
	strokeWidth?: number;
}

/**
 * The "wand" icon used everywhere the dashboard means "AI": the assistant
 * trigger, generate/regenerate buttons and AI badges. Drawn with strokes on a
 * 16px grid; colour follows `color` (or the surrounding text colour).
 */
const AiIcon: React.FC<AiIconProps> = ({
	size = 16,
	color = "currentColor",
	strokeWidth = 1,
	...rest
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 16 16"
		aria-hidden="true"
		focusable="false"
		{...rest}
	>
		<g
			fill="none"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<polygon points=".5 13.5 2.5 15.5 11 7 9 5 .5 13.5" />
			<line x1="7" y1="7" x2="9" y2="9" />
			<line x1="8.5" y1=".5" x2="8.5" y2="2.5" />
			<line x1="3.5" y1="2.5" x2="5" y2="4" />
			<line x1="15.5" y1="7.5" x2="13.5" y2="7.5" />
			<line x1="13.5" y1="12.5" x2="12" y2="11" />
			<line x1="13.5" y1="2.5" x2="12" y2="4" />
		</g>
	</svg>
);

export default AiIcon;
